"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    color: palette.tLabel,
    fontSize: palette.tsXSmall,
    lineHeight: palette.tlXSmall,
    fontFamily: palette.fontFamily
  };
}